import { createWorkerAction } from '../lib';

// TODO: remove after releasing yoshi in Editor & Viewer
export const performanceApplicationLoaded = createWorkerAction(
  'PERFORMANCE_APPLICATION_LOADED',
);
